import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../common/Loading';

/**
 * PublicRoute - Redirects authenticated users away from public pages (login/signup)
 * If user is authenticated, redirects to appropriate dashboard based on role
 * If user is not authenticated, shows the public page
 */
const PublicRoute = ({ children }) => {
  const { user, loading, isAuthenticated, isSuperAdmin } = useAuth();

  if (loading) {
    return <Loading fullScreen />;
  }

  // If user is authenticated, redirect to appropriate dashboard
  if (isAuthenticated) {
    // Super admins go to super admin dashboard
    if (isSuperAdmin) {
      return <Navigate to="/super-admin/dashboard" replace />;
    }
    // All other authenticated users go to regular dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // If user is not authenticated, show the public page (login/signup)
  return children;
};

export default PublicRoute;
